export const rpudrInforce = (
  year,
  age,
  noLapseGuarantee,
  accountValuePlusBonusAtMonthEnd,
  basicMaximumCoverageAge,
  prevYear,
  prevMonth
) => {
  return (
    year <= noLapseGuarantee ||
    (year > noLapseGuarantee &&
      ((accountValuePlusBonusAtMonthEnd > 0 && age < basicMaximumCoverageAge) ||
        (prevYear <= noLapseGuarantee && prevMonth === 12)))
  )
}

export const rpudrRiderInforce = (
  age,
  attainedAge,
  minimumIssueAge,
  maximumIssueAge,
  maximumCoverageAge,
  isBasicInforce
) => {
  const isBetweenIssueAge = age >= minimumIssueAge && age <= maximumIssueAge
  return isBetweenIssueAge && isBasicInforce ? attainedAge < maximumCoverageAge : false
}
